import { React, useEffect, useState } from "react";
import img_escarabajos from "../../../assets/images/img_escarabajos.png";
import ico_escarabajo from "../../../assets/icons/ico_escarabajo.svg";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import GroupInfoSection from "../../../components/groupInfoSection";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const DungBeetlesScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const arenoso = "https://drive.google.com/uc?export=download&id=1aM3soWjqgk3PIEHW4GW6-u8SfZUGqbML";
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);
  //bg-white w-full md:max-w-md lg:max-w-full md:mx-auto  md:w-1/2 xl:w-1/3 h-screen px-6 lg:px-16 xl:px-12 flex items-center justify-center
  return (
    <div className="bg-[#002E0F] h-full">
      {width > 1300 ? (
        <div>
          <div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
            <div className="relative w-full lg:h-full">
              <VideoGroupsBanner videoSource={arenoso} left="3%" />
              <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
                <GoToPage
                  page="/grupos"
                  side="left"
                  name="Atrás"
                  fontsize="text-lg"
                  textColor="text-white"
                  borderType="border-b-2"
                  borderColor="border-white"
                  iconSize="h-4"
                  iconColor="invert"
                  iconMargin="mr-5"
                ></GoToPage>
              </div>
              <img
              
                src={img_escarabajos}
                alt=""
                className="w-full  pr-[19.5rem] z-40 bottom-0 absolute"
              />
            </div>

            <GroupInfoSection
              webvrurl="https://niv2.vercel.app/"
              icon={ico_escarabajo}
              title={<p>Escarabajos Estercoleros</p>}
              subTitle=""
              textFirstTab={
                <p>
                  Los escarabajos estercoleros son insectos que tienen una
                  relación directa con otros animales debido al consumo y a la
                  dispersión que hacen de su excremento. Se alimentan
                  principalmente de las heces de mamíferos y otros vertebrados.
                </p>
              }
              textSecondTab={
                <p>
                  Por alimentarse de excremento de vertebrados, este grupo de
                  escarabajos responde rápidamente a la perturbación ambiental y
                  nos brinda información sobre las complejas relaciones entre
                  los insectos, mamíferos y aves que habitan un determinado
                  lugar.
                </p>
              }
              textThirdTab={
                <p>
                 Con los escarabajos coprófagos es fácil realizar estudios para monitorear distintos tipos de paisaje como: áreas de cultivo, bosques secundarios, bosques maduros y pastizales. Los métodos se aplican a nivel del suelo, donde normalmente se encuentran este tipo de animales, en época seca y lluviosa. Además, se pueden realizar comparaciones de las distintas especies y sus funciones ecológicas por sitio.
                </p>
              }
            ></GroupInfoSection>
          </div>
        </div>
      ) : (
        <div className="min-h-[100vh] grid grid-cols-1 h-full">
        <div className=" bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
          <GoToPage
            page="/grupos"
            side="left"
            name="Atrás"
            fontsize="text-lg"
            textColor="text-white"
            borderType="border-b-2"
            borderColor="border-white"
            iconSize="h-4"
            iconColor="invert"
            iconMargin="mr-5"
          ></GoToPage>
        </div>
        <div style={{"z-index":"1"}}>
        <GroupInfoSection
              webvrurl="https://niv2.vercel.app/"
              icon={ico_escarabajo}
              title={<p>Escarabajos Estercoleros</p>}
              subTitle=""
              textFirstTab={
                <p>
                  Los escarabajos estercoleros son insectos que tienen una
                  relación directa con otros animales debido al consumo y a la
                  dispersión que hacen de su excremento. Se alimentan
                  principalmente de las heces de mamíferos y otros vertebrados.
                </p>
              }
              textSecondTab={
                <p>
                  Por alimentarse de excremento de vertebrados, este grupo de
                  escarabajos responde rápidamente a la perturbación ambiental y
                  nos brinda información sobre las complejas relaciones entre
                  los insectos, mamíferos y aves que habitan un determinado
                  lugar.
                </p>
              }
              textThirdTab={
                <p>
                  Con los escarabajos coprófagos es fácil realizar estudios para monitorear distintos tipos de paisaje como: áreas de cultivo, bosques secundarios, bosques maduros y pastizales. Los métodos se aplican a nivel del suelo, donde normalmente se encuentran este tipo de animales, en época seca y lluviosa. Además, se pueden realizar comparaciones de las distintas especies y sus funciones ecológicas por sitio.
                </p>
              }
            ></GroupInfoSection>
        </div>
        <div className="relative w-full lg:h-full flex justify-center lg:mt-44 md:mt-32 sm:mt-20 mt-20">
        <div className=" lg:mb-40 md:mb-64 sm:b-24 mb-24">
            <GroupsVideoFooter videoSource={arenoso} />
            </div>
         
          <img
          
            src={img_escarabajos}
            alt=""
            className="lg:w-full md:w-full sm:w-full w-full lg:h-[50rem] md:h-[40rem]  sm:h-[25rem] h-[15rem] bottom-0 absolute "
          />
        </div>
      </div>
      )}
    </div>
  );
};

export default DungBeetlesScreen;
